import { makeStyles } from '@mui/styles';

export const useDeliveryContainerHoverCardStyles = makeStyles(() => ({
  root: {
    padding: '16px',
    // Width of DeliveryCard component plus padding
    width: '495px',
    minHeight: '180px',
    borderRadius: '10px',
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  },
  title: {
    fontSize: '14px',
    margin: 0,
    fontWeight: 600
  },
  contentsTitle: {
    textTransform: 'uppercase',
    fontSize: '12px',
    color: '#979797'
  },
  noContentsMessage: {
    fontSize: '14px',
    lineHeight: 1.5
  }
}));
